import { toggleFavouriteProperty, getFavouriteProperties } from '../services/favourite_property.service';

const ADD = 'add';
const REMOVE = 'remove'


export default (isAuthenticated) => ({
  isAuthenticated: isAuthenticated === 'True',
  favouritesIds: [],
  init: function () {
    if (!this.isAuthenticated) return
    getFavouriteProperties({
      onResponse: (response) => {
        this.favouritesIds = response.data.favourites
      },
      onError: (error) => console.log(error)
    })
  },
  isFavourite: function (entityId) {
    return this.isAuthenticated && this.favouritesIds.includes(entityId);
  },
  toggleFavourite: function(entityId, csrfToken) {
    if (!this.isAuthenticated) {
      this.redirectToLoginPage()
      return
    }
    this.isFavourite(entityId)
    ? this.removeFavourite(entityId, csrfToken)
    : this.addFavourite(entityId, csrfToken)
  },
  removeFavourite: function(entityId, csrfToken ) {
    toggleFavouriteProperty({
      id: entityId,
      csrfToken: csrfToken,
      eventType: REMOVE,
      onResponse: () => { this.favouritesIds = this.favouritesIds.filter(a => a != entityId); },
      onError: () => {},
    })
  },
  addFavourite: function(entityId, csrfToken ) {
    toggleFavouriteProperty({
      id: entityId,
      csrfToken: csrfToken,
      eventType: ADD,
      onResponse: () => { this.favouritesIds.push(entityId); },
      onError: () => {},
    })
  },
  redirectToLoginPage: function() {
    const loginPage = 'login';
    window.location.pathname = loginPage;
  }
});
